import React from "react";
import { ReactComponent as CallIcon } from "../../../assets/icons/call.svg";
import axios from "axios";
import { useEffect, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import { ReactComponent as Outgoing } from "../../../assets/icons/outgoingcall.svg";

const RecentCalls = (props) => {
  
const recentCalls = props.recentCalls
console.log("RECENT CALLS ------   :  ",recentCalls)

  return (
    <div className="font-karla">
      <div className="p-6 ">
        <div className="flex justify-between items-center pt-4 space-x-4">
          <div className="bg-light-white rounded-md w-full h-16 pt-2">
            <h1 className="text-center font-bold text-lg text-gray-700">{recentCalls?.recent_calls?.answerd_calls || 0}</h1>
            <p className="text-center text-sm text-gray-700">Answered</p>
          </div>
          <div className="bg-light-white rounded-md w-full h-16 pt-2">
            <h1 className="text-center font-bold text-lg text-gray-700">{recentCalls?.recent_calls?.notanswerd_calls || 0}</h1>
            <p className="text-center text-sm text-gray-700">Not Answered</p>
          </div>
        </div>
        <div className="flex justify-between items-center pt-4 space-x-4">
          <div className="bg-light-white rounded-md w-full h-16 pt-2">
            <h1 className="text-center font-bold text-lg text-gray-700	">{recentCalls?.recent_calls?.busy_calls || 0}</h1>
            <p className="text-center text-sm text-gray-700	">Busy</p>
          </div>
          <div className="bg-light-white rounded-md w-full h-16 pt-2">
            <h1 className="text-center font-bold text-lg text-gray-700	">{recentCalls?.recent_calls?.nochannel_calls || 0}</h1>
            <p className="text-center text-sm text-gray-700	">Not Available</p>
          </div>
          <div className="bg-light-white rounded-md w-full h-16 pt-2">
            <h1 className="text-center font-bold text-lg text-gray-700	">{recentCalls?.recent_calls?.unavailable_calls || 0}</h1>
            <p className="text-center text-sm text-gray-700	">No Channel</p>
          </div>
        </div>
      </div>
      <h1 className="font-bold text-[20px] p-7 pb-0">Call Logs</h1>

      <div className="overflow-auto no-scrollbar p-4 h-[500px] overflow-y-auto">
      <table className="w-full">
          <tbody>

          { recentCalls?.recent_calls_objs && recentCalls?.recent_calls_objs.map && recentCalls?.recent_calls_objs.map((obj, index) => (
         
            <tr className="text-[16px] font-karla text-gray-900  whitespace-nowrap">
          <td className="py-4 px-4">
            <p>{obj.date}</p>
            <p className="text-gray-400">{obj.AnswerdAgent}</p>


          </td>
          <td className="px-4  py-4 text-center">
            <div className="flex justify-start gap-2">
              <div className="mt-[4px]">
              <Outgoing width={12} height={12}  fill={`${obj.callStatus == "ANSWERED"? "green": "red"}`}/>
              </div>
            <p>{obj.callStatus}</p>
            </div>
            <p className="text-gray-400 flex">
              
              {/* <svg
                width="12"
                height="14"
                viewBox="0 0 14 16"
                fill={`${obj.callStatus == "ANSWERED"? "green": "red"}`}
                xmlns="http://www.w3.org/2000/svg"
                className="mt-1 mr-[4px]"
              >
                <path d="M12.2238 9.54928C12.0697 9.52442 11.9166 9.45001 11.7682 9.39056C11.4673 9.2723 11.1755 9.13266 10.8951 8.97272C10.5894 8.80354 10.2311 8.752 9.88921 8.82802C9.5473 8.90404 9.24589 9.10224 9.04299 9.3845L8.83729 9.67102C8.21623 9.18429 7.66416 8.6174 7.19589 7.98554C6.74113 7.34668 6.37257 6.65201 6.09952 5.91908L6.43987 5.77504C6.77537 5.67492 7.06156 5.45581 7.24336 5.15987C7.42517 4.86393 7.48975 4.51208 7.42467 4.17202C7.36243 3.85823 7.3213 3.54071 7.30156 3.22153C7.29288 3.05674 7.29007 2.9 7.29541 2.73747C7.29105 2.23637 7.10567 1.75332 6.77266 1.37532C6.43964 0.997324 5.98087 0.749211 5.47896 0.675665L3.37717 0.336771C3.08106 0.288632 2.77796 0.302847 2.48776 0.378483C2.19756 0.454119 1.9268 0.589469 1.69324 0.775661C1.45569 0.966463 1.26258 1.20559 1.12706 1.47674C0.991535 1.74789 0.916791 2.04469 0.90792 2.34691C0.797114 5.30355 1.68615 8.21219 3.43479 10.614C5.18343 13.0158 7.69214 14.7741 10.5652 15.6116C10.655 15.6331 10.7464 15.6478 10.8384 15.6556C11.3959 15.7455 11.9667 15.613 12.4253 15.2873C12.884 14.9616 13.1928 14.4693 13.284 13.9187L13.6278 11.8429C13.7005 11.359 13.6001 10.8651 13.3438 10.4465C13.0875 10.0278 12.6915 9.71056 12.2238 9.54928ZM11.8795 13.7562C11.8641 13.8567 11.8267 13.9527 11.7699 14.0375C11.7132 14.1223 11.6385 14.1939 11.5509 14.2473C11.4634 14.3008 11.3651 14.3348 11.263 14.3471C11.1608 14.3593 11.0572 14.3495 10.9592 14.3182C8.39916 13.5593 6.16409 11.9879 4.60014 9.84741C3.04076 7.68842 2.24861 5.08037 2.34719 2.42979C2.34878 2.32586 2.37375 2.22356 2.42029 2.13032C2.46684 2.03707 2.53379 1.95521 2.61631 1.89065C2.69326 1.82817 2.78265 1.78238 2.87869 1.75625C2.97472 1.73012 3.07524 1.72424 3.17371 1.73899L5.2755 2.07788C5.43902 2.10057 5.58939 2.17885 5.70074 2.29924C5.81209 2.41963 5.87745 2.5746 5.88557 2.73747C5.88227 2.93112 5.88636 3.12359 5.89784 3.31488C5.91836 3.69268 5.96671 4.06849 6.04249 4.43934L4.98716 4.73094C4.89701 4.75542 4.81263 4.79724 4.73887 4.85401C4.66512 4.91078 4.60344 4.98137 4.55738 5.06174C4.51132 5.14211 4.48179 5.23066 4.47048 5.32232C4.45916 5.41398 4.46629 5.50694 4.49146 5.59585C5.14649 7.89148 6.59862 9.88605 8.59346 11.2301C8.75257 11.3268 8.94389 11.3577 9.12592 11.316C9.31035 11.2801 9.47288 11.1735 9.57784 11.0194L10.1797 10.1219C10.5207 10.3082 10.8727 10.4741 11.2339 10.6187C11.4092 10.6896 11.5996 10.7558 11.7842 10.814C11.9364 10.8746 12.0626 10.9855 12.1414 11.1277C12.2201 11.2699 12.2465 11.4347 12.216 11.594L11.8795 13.7562Z" />
              </svg> */}

              {obj.CustomerNumber}
            </p>
            
          </td>
          <td className="p-3">{obj.callDuration}</td>
            </tr>
         ))}

          </tbody>
      </table>
      </div>
    </div>
  );
};

export default React.memo(RecentCalls);
